
$('#myModal').ready(function() {
  var modal = document.getElementById('myModal');
  var closeBtn = document.getElementById("closePopup");
    var close = document.getElementById("continue-browsing");
  close.onclick = function() {
	modal.style.display = "none";
  	$.cookie("LOC", "auth", {
        expires : 30,
        path: '/',
      });
}
closeBtn.onclick = function() {
	modal.style.display = "none";
  	$.cookie("LOC", "auth", {
        expires : 30,
        path: '/',
      });
}

  checkLoc();
})

function checkLoc(){
    $.getJSON("https://geolocation-db.com/json/85249190-4601-11eb-9067-21b51bc8dee3", function(response){
    
    if(response.country_code != 'CA') {

      var modal = document.getElementById('myModal');
      var LOC = $.cookie('LOC');
          
      if (LOC == 'auth') {
        modal.style.display = "none";
      } else {
        modal.style.display = "block";
        $.cookie("LOC", "unauth", {
          expires : 30,
          path: '/',
        
        });
      }  
                

    }

  });
}


